import React from "react";
import { twMerge } from "tailwind-merge";

type Props = {
  gutterBottom?: boolean;
  children?: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
};

const IsGutterBottom = (gutterBottom: boolean) => gutterBottom && "mb-[0.35em]";

const H1: React.FC<Props> = (props) => (
  <h1
    className={twMerge(
      IsGutterBottom(props.gutterBottom),
      "text-8xl leading-[1.167] ",
      props.className,
    )}
    style={props.style}
  >
    {props.children}
  </h1>
);

const H2: React.FC<Props> = (props) => (
  <h2
    className={twMerge(
      IsGutterBottom(props.gutterBottom),
      "text-6xl leading-tight ",
      props.className,
    )}
    style={props.style}
  >
    {props.children}
  </h2>
);

const H3: React.FC<Props> = (props) => (
  <h3
    className={twMerge(
      IsGutterBottom(props.gutterBottom),
      "text-5xl leading-[1.167]",
      props.className,
    )}
    style={props.style}
  >
    {props.children}
  </h3>
);

const ResponsiveH3: React.FC<Props> = (props) => (
  <h3
    className={twMerge(
      IsGutterBottom(props.gutterBottom),
      "text-2xl md:text-3xl font-medium leading-[1.167]",
      props.className,
    )}
    style={props.style}
  >
    {props.children}
  </h3>
);

const H4: React.FC<Props> = (props) => (
  <h4
    className={twMerge(
      IsGutterBottom(props.gutterBottom),
      "text-4xl",
      props.className,
    )}
    style={props.style}
  >
    {props.children}
  </h4>
);

const H5: React.FC<Props> = (props) => (
  <h5
    className={twMerge(
      IsGutterBottom(props.gutterBottom),
      "text-2xl leading-snug",
      props.className,
    )}
    style={props.style}
  >
    {props.children}
  </h5>
);

export const Heading = {
  H1,
  H2,
  H3,
  ResponsiveH3,
  H4,
  H5,
};

export default Heading;
